// i18nOwl-ignore [app-instagram.triggerIntegrations.connect-account.title]
import type {TriggerIntegration} from '@cohort/merchants/apps';
import InstagramConnectedAccountTriggerIntegrationConfigComponent from '@cohort/merchants/apps/instagram/triggerIntegrations/connectAccount/ConfigComponent';
import InstagramConnectAccountTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/instagram/triggerIntegrations/connectAccount/StepCompletionTitleComponent';
import type {InstagramConnectAccountTriggerStruct} from '@cohort/shared/schema/apps/instagram/triggers/connectAccount';
import {InstagramConnectAccountTriggerIntegrationSpec} from '@cohort/shared/schema/apps/instagram/triggers/connectAccount';

export const InstagramConnectAccountTriggerIntegration: TriggerIntegration<InstagramConnectAccountTriggerStruct> =
  {
    spec: InstagramConnectAccountTriggerIntegrationSpec,
    configComponent: InstagramConnectedAccountTriggerIntegrationConfigComponent,
    stepCompletionTitleComponent:
      InstagramConnectAccountTriggerIntegrationStepCompletionTitleComponent,
  };
